import moment from 'moment';

export enum DateFilter {
  ThisWeek = 'THIS_WEEK',
  LastWeek = 'LAST_WEEK',
  ThisMonth = 'THIS_MONTH',
  LastMonth = 'LAST_MONTH',
  ThisQuarter = 'THIS_QUARTER',
  LastQuarter = 'LAST_QUARTER',
  Last90Days = 'LAST_90_DAYS',
}

const STORAGE_KEY = 'signal_reason_view';

interface StoredFilter {
  dateFilter: DateFilter;
}

export const getStoredDateFilter = (): DateFilter => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (!stored) {
      return DateFilter.Last90Days;
    }
    const data: StoredFilter = JSON.parse(stored);

    return data.dateFilter || DateFilter.Last90Days;
  } catch {
    return DateFilter.Last90Days;
  }
};

export const saveDateFilter = (filter: DateFilter): void => {
  try {
    const data: StoredFilter = { dateFilter: filter };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // Silently fail if localStorage is not available
  }
};

export const getDateRangeFromFilter = (
  filter: DateFilter,
): { startDate: string; endDate: string } => {
  const now = moment();
  let startDate: moment.Moment;
  let endDate: moment.Moment = now.clone().endOf('day');

  switch (filter) {
    case DateFilter.ThisWeek:
      startDate = now.clone().startOf('week');
      break;
    case DateFilter.LastWeek:
      startDate = now.clone().subtract(1, 'week').startOf('week');
      endDate = now.clone().subtract(1, 'week').endOf('week');
      break;
    case DateFilter.ThisMonth:
      startDate = now.clone().startOf('month');
      break;
    case DateFilter.LastMonth:
      startDate = now.clone().subtract(1, 'month').startOf('month');
      endDate = now.clone().subtract(1, 'month').endOf('month');
      break;
    case DateFilter.ThisQuarter:
      startDate = now.clone().startOf('quarter');
      break;
    case DateFilter.LastQuarter:
      startDate = now.clone().subtract(1, 'quarter').startOf('quarter');
      endDate = now.clone().subtract(1, 'quarter').endOf('quarter');
      break;
    case DateFilter.Last90Days:
    default:
      startDate = now.clone().subtract(90, 'days').startOf('day');
      break;
  }

  return {
    startDate: startDate.format('YYYY-MM-DD'),
    endDate: endDate.format('YYYY-MM-DD'),
  };
};

export const getFilterLabelKey = (filter: DateFilter): string => {
  switch (filter) {
    case DateFilter.ThisWeek:
      return 'accounts.page.signals_v2.reasons.filter.this_week';
    case DateFilter.LastWeek:
      return 'accounts.page.signals_v2.reasons.filter.last_week';
    case DateFilter.ThisMonth:
      return 'accounts.page.signals_v2.reasons.filter.this_month';
    case DateFilter.LastMonth:
      return 'accounts.page.signals_v2.reasons.filter.last_month';
    case DateFilter.ThisQuarter:
      return 'accounts.page.signals_v2.reasons.filter.this_quarter';
    case DateFilter.LastQuarter:
      return 'accounts.page.signals_v2.reasons.filter.last_quarter';
    case DateFilter.Last90Days:
    default:
      return 'accounts.page.signals_v2.reasons.filter.last_90_days';
  }
};
